<template>
	<div>
		<navigation></navigation>
		<div class="line"></div>
		<div v-if="flag == 4">
			暂无内容
		</div>
		<div v-else>
			<div v-if="process == 1" style="width: 90%;margin: 0 auto;" v-for="(item,index) in dailyList" :key="index">
				<el-collapse v-model="activeName" accordion>
					<el-collapse-item :title="item.title" :name="index">
						<div style="display: flex;" @click="show(item)">
							<div style="width: 82%;">
								<span style="width: 100%;display: inline-block;">{{item.content}}</span>
							</div>
							<div>
								<img :src="item.imgUrl" alt="" style="width: 60px;height: 60px;">
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
			<div v-if="process == 2">
				<div v-if="flag == 1">
					<img :src="url" alt="" style="width: 100%;">
				</div>
			</div>
		</div>

		<logocom v-if="flag == 0 || flag == 4" style="margin-top: 150px;"></logocom>
		<div v-else class="btn-box" :class="$route.path == '/signIn'? 'ishow':''">
			<div class="retrun_phone" @click="back">返回</div>
		</div>
	</div>
</template>

<script>
	import logocom from '@/components/logo/logo.vue';
	import navigation from '@/components/navigation/navigation.vue';
	import axios from 'axios';
	import Video from 'video.js';
	import 'video.js/dist/video-js.css';
	export default {
		data() {
			return {
				drawerVisible: false,
				activeName: 0,
				dailyList: {},
				process: 1,
				url: '',
				flag: 0,
			}
		},
		methods: {
			show(item) {
				this.url = item.details;
				this.flag = item.flag;
				if (item.flag == 1) {
					this.process++;
					this.step++;
				}if (item.flag == 2) {
					window.open("https://view.officeapps.live.com/op/view.aspx?src=" + item.details)
				}
				if (item.flag == 3) {
					window.open(item.details)
				}
			},
			back() {
				if (this.process < 4) {
					if (this.process > 1 && this.process <= 2) {
						this.process--
					} else {
						this.step--
					}
				}
				this.flag = 0;
			}


		},
		components: {
			navigation,
			logocom,
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (!flag) {
				this.$router.push({
					path: '/'
				})
			}
			axios.get('https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/dailyList/dailyList.json').then(res => {
				var list = res.data.item;
				console.log("list",list.[0].title)
				if(list.[0].title == "") {
					this.flag = 4;
				}
				this.dailyList = res.data.item;
				
			}, res => {
				console.log("error")
			})

		},
	}
</script>

<style scoped>
	.dailyList {
		width: 90%;
		margin: 0 auto;
		height: 80px;

	}

	.dailyList ul {

		padding: 0;
	}

	.dailyList ul li {
		list-style: none;
		height: 100%;
	}

	.dailyList li span {
		display: inline-block;
		width: 80%;
		line-height: 30px;
	}

	.dailyList li label {
		display: inline-block;
		width: 80%;
		line-height: 30px;
	}

	.dailyList li img {
		width: 60px;
		height: 60px;
	}

	.retrun_phone {
		/* 	font-size: 20px;
		font-weight: bold;
		color: #1e65ff;
		text-align: center;
		margin-bottom: 30px;
		background-color: #eeeeee; */
		margin: 0 auto;
		line-height: 40px;
		text-align: center;
		background-color: #5e89ff;
		color: #fff;
		border-radius: 5px;
		width: 80%;
		/* margin-bottom: 20px; */
		position: fixed;
		bottom: 10px;
		margin-left: 50%;
		transform: translateX(-50%);

	}
</style>
